import React from 'react';
import { useGetGsapeQuizQuery } from './NewGsapQuizSlice';
import Loading from 'components/global/layout/Loading';
import GsapAptitudeInstructions from './GsapAptitudeInstructions';

const GetGsapAptitudeQuestion = () => {
  // changed this: useGetGsapeQuizQuery , according to new aptitude slice
  const { isLoading, isError, data } = useGetGsapeQuizQuery();
  return (
    <div>
      {isLoading || isError ? (
        <Loading />
      ) : (
        <GsapAptitudeInstructions data={data} />
      )}
    </div>
  );
};

export default GetGsapAptitudeQuestion;
